import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { Question } from 'src/app/models/inspections/question';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, MessageService, params, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { QuestionsComponent } from '../questions/questions.component';
import { QuestionForm } from 'src/app/models/inspections/question-form';
import { RouterEvent } from '@angular/router';

@Component({
    selector: 'app-modal-generic-question',
    templateUrl: './modal-generic-question.component.html',
    styleUrls: ['./modal-generic-question.component.scss'],
    standalone: false
})
export class ModalGenericQuestionComponent implements OnInit {
  public EndpointDictionary = EndpointDictionary;
  public questions: Question[] = [];

  public reloadTableQ = new EventEmitter<any>();
  public configurationQ: TableConfiguration = {
    add:true,
    addPer: true,
    selectable: true,
    primaryKey: 'id'
  };
  public columnsQ: TableColumns<Question>[] = [
    {
      ID: 'question',
      label: 'Pregunta',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '70%',
      },
    },
    {
      ID: 'responseType',
      label: 'Tipo de respuesta',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '30%',
      },
    },
  ];

  public paramsQuestions: params[] = [{ id: 'formId', value: '0' }];

  constructor(
    public dialogRef: MatDialogRef<ModalGenericQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private http: HttpService,
    private message: MessageService,
    public dialog: MatDialog,
    private session: SessionService,
  ) {}

  ngOnInit(): void {
    if (this.data.body) {
      this.paramsQuestions = [{ id: 'formId', value: this.data.body.id }];
    }
  }

  selectdQuestions($event: Question[]) {
    this.questions = $event.map(question => ({
      ...question,
      responses: question.responseType.split('/').map(response => response.trim())
    }));
    return
  }

  async finalizar() {
    const result: Question[] = this.questions.map((element) => ({
      id: element.id,
      question: element.question,
      responses: element.responses,
    }));

    const body = {
      formId: this.data.body.id,
      questions: this.questions.map((element, index) => ({
        id: element.id,
        orderNumber: index,
      })),
    };

    let res: QuestionForm[] = await this.http.postDataBody(
      `${EndpointDictionary.QuestionInspectionForm.CRUD_QUESTION_FORM_DATA}`,
      body
    );
    if (res.length > 0) {
      result.forEach((item) => {
        const matchingRes = res.find((r) => r.questionId === item.id);
        if (matchingRes) {
          item.questionIdByForm = matchingRes.id;
          item.orderNumber = matchingRes.orderNumber;
        }
      });
      
      this.message.SuccessToast(`Pregunta asociada a formulario correctamente`);
      this.dialogRef.close();
    }

    this.dialogRef.close(result);
  }

  addQuestions($event: Event | RouterEvent) {
    let size: number = screen.width > 500 ? 60 : 50;
    this.session.setData('redireccion', 'nuevo');
    this.dialog
          .open(QuestionsComponent, {
            width: `${size}vh`,
          })
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.reloadTableQ.emit();
            }
          });
    

  }
}
